import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  FormControl,
  TextField,
  Button,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { get_root_value } from "src/utils/domUtils";
import moment from "moment";
import { AddWorkoutAgainstMemberApi } from "src/DAL/workout/workout";
import { useSnackbar } from "notistack";
import MUIAutocomplete from "src/components/GeneralComponents/MUIAutocomplete";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { program_workout_reciever_list_api } from "src/DAL/programmeWorkout/programmeWorkout";

function WorkoutAssign({ open, setOpen, data }) {
  const { enqueueSnackbar } = useSnackbar();
  const [serchText, setSerchText] = useState("");
  const [programsList, setProgramsList] = useState([]);
  const [membersList, setMembersList] = useState([]);
  const [serchTextMember, setSerchTextMember] = useState("");
  const [isLoading, setisLoading] = useState(false);

  const [inputs, setInputs] = useState({
    reciever_type: "program",
    programme: null,
    members: null,
    workout_date: new Date(),
    programs_id: null,
    workout_day: "",
  });

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => ({ ...prev, [name]: value }));
    if (name === "reciever_type") {
      setSerchText("");
      setProgramsList([]);
      setMembersList([]);
      setInputs((prev) => ({ ...prev, programme: null, members: null }));
    }
  };

  const getProgrammesList = async (type, serch) => {
    let result = await program_workout_reciever_list_api(type, serch);
    if (result.code === 200) {
      if (type === "program") {
        let data = result.response.map((program) => {
          let title = program.title + " (" + program.program_length_type + ")";
          return {
            ...program,
            title,
          };
        });
        setProgramsList(data);
      } else {
        let data = result.response.map((member) => {
          let title =
            member.first_name +
            " " +
            member.last_name +
            " (" +
            member.email +
            ")";
          return {
            ...member,
            title,
          };
        });
        setMembersList(data);
      }
    }
  };

  const handleChangeOthers = (e, name) => {
    setInputs((prev) => ({ ...prev, [name]: e }));
    if (name === "members") {
      setInputs((prev) => ({ ...prev, ["programme"]: null }));
    }
  };

  const handleSaveExistingWorkout = async (e) => {
    e.preventDefault();

    if (
      inputs?.programme?.program_length_type === "unlimited" &&
      (!inputs.workout_date || isNaN(new Date(inputs.workout_date).getTime()))
    ) {
      enqueueSnackbar("Please enter a valid Date", { variant: "error" });
      return;
    }

    if (
      !inputs?.programme?.program_length_type === "unlimited" &&
      (!inputs.workout_day || Number(inputs.workout_day) <= 0)
    ) {
      enqueueSnackbar("Please enter a valid Day greater than 0", {
        variant: "error",
      });
      return;
    }
    setisLoading(true);
    const formDataObject = {
      workout_id: data?._id,
      program_id: inputs?.programme?._id,
      workout_day: inputs?.workout_day,
      workout_date: moment(inputs.workout_date).format("YYYY-MM-DD"),
      member_id: inputs?.members?._id,
      type: inputs?.reciever_type,
    };

    if (data?.practice_type === "food") {
      formDataObject.meals = JSON.stringify(data.meals || []);
    }

    const result = await AddWorkoutAgainstMemberApi(formDataObject);
    if (result.code === 200) {
      setOpen(false);
      setisLoading(false);
      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      setisLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  useEffect(() => {
    if (inputs.members) {
      let data = inputs.members.program.map((program) => {
        let title = program.title + " (" + program.program_length_type + ")";
        return {
          ...program,
          title,
        };
      });
      data = data.filter((program) => program.access_status === true);
      setProgramsList(data);
    }
  }, [inputs.members]);

  useEffect(() => {
    getProgrammesList(inputs.reciever_type, serchText);
  }, [inputs.reciever_type, serchText]);

  return (
    <>
      <Dialog
        open={open}
        maxWidth={"sm"}
        fullWidth
        PaperProps={{
          style: {
            backgroundColor: "white",
            color: "black",
            boxShadow: "none",
          },
        }}
      >
        <div
          className={`text-end mt-1 d-flex justify-content-between align-items-center`}
        >
          <DialogTitle
            sx={{
              paddingY: 0,
              color: get_root_value("--portal-theme-primary"),
            }}
          >
            Add To Programme/Member
          </DialogTitle>
          <IconButton
            className="back-screen-button me-1 "
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <DialogContent>
          <form className="row" onSubmit={handleSaveExistingWorkout}>
            <div className="col-12">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Added In</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="reciever_type"
                  value={inputs.reciever_type}
                  label="Added In"
                  onChange={handleChange}
                >
                  <MenuItem value="program">Programme</MenuItem>
                  <MenuItem value="member">Member</MenuItem>
                </Select>
              </FormControl>
            </div>
            {inputs.reciever_type === "member" && (
              <div className="col-12 mt-3">
                <MUIAutocomplete
                  inputLabel="Members"
                  required={true}
                  selectedOption={inputs.members}
                  setSelectedOption={(e) => {
                    handleChangeOthers(e, "members");
                  }}
                  optionsList={membersList}
                  setCustomSearch={setSerchText}
                  autoComplete="new-password"
                  name="title"
                />
              </div>
            )}
            <div className="col-12 mt-3">
              <MUIAutocomplete
                inputLabel="Programme"
                required={true}
                selectedOption={inputs.programme}
                setSelectedOption={(e) => {
                  handleChangeOthers(e, "programme");
                }}
                optionsList={programsList}
                setCustomSearch={
                  inputs.reciever_type === "member"
                    ? setSerchTextMember
                    : setSerchText
                }
                autoComplete="new-password"
                name="title"
              />
            </div>
            {inputs?.programme && (
              <>
                {inputs.programme.program_length_type === "unlimited" ? (
                  <div className="col-12 mt-3">
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DesktopDatePicker
                        label="Target Date"
                        inputFormat="dd/MM/yyyy"
                        value={inputs.workout_date}
                        onChange={(e) => {
                          handleChangeOthers(e, "workout_date");
                        }}
                        renderInput={(params) => (
                          <TextField fullWidth {...params} required />
                        )}
                      />
                    </LocalizationProvider>
                  </div>
                ) : (
                  <div className="col-12 mt-3">
                    <TextField
                      id="outlined-basic"
                      label={`No Of Day (1 to ${
                        inputs.programme?.no_of_weeks * 7
                      })`}
                      variant="outlined"
                      type="number"
                      InputProps={{
                        inputProps: {
                          min: 1,
                          max: inputs.programme?.no_of_weeks
                            ? inputs.programme.no_of_weeks * 7
                            : undefined,
                        },
                      }}
                      placeholder={`No Of Day (1 to ${
                        inputs.programme?.no_of_weeks * 7
                      })`}
                      required
                      fullWidth
                      name="workout_day"
                      value={inputs.workout_day}
                      onChange={(e) => {
                        handleChangeOthers(e.target.value, "workout_day");
                      }}
                      className="w-100"
                    />
                  </div>
                )}
              </>
            )}
            <div className="text-end mt-4">
              <Button variant="contained" type="submit" disabled={isLoading}>
                {isLoading ? "Submitting..." : "Submit"}
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default WorkoutAssign;
